import { Routes } from '@angular/router';
import { CruiseDestinationsType01Component } from './cruise-destinations-type01/cruise-destinations-type01.component';
export default [
    {
        path     : '',
        component: CruiseDestinationsType01Component,
    },
    
] as Routes;
